"use client";
import { ModalType } from "@/modules/Insta/Modal/Modal";
import { usePathname } from "next/navigation";
import React, {
  createContext,
  Dispatch,
  SetStateAction,
  useContext,
  useEffect,
  useState,
} from "react";

export interface IContextType {
  openMenu: boolean;
  setOpenMenu: Dispatch<SetStateAction<boolean>>;
  openPopup: boolean;
  setopenPopup: Dispatch<SetStateAction<boolean>>;
  instagramModal: ModalType | null;
  setInstagramModal: Dispatch<SetStateAction<ModalType | null>>;
}

const AppContext = createContext<IContextType | null>(null);

export const AppProvider = ({ children }: { children: React.ReactNode }) => {
  const [openMenu, setOpenMenu] = useState<boolean>(false);
  const [openPopup, setopenPopup] = useState<boolean>(false);
  const [instagramModal, setInstagramModal] = useState<ModalType | null>(null);
  const pathname = usePathname();

  useEffect(() => {
    setOpenMenu(false);
  }, [pathname]);

  return (
    <AppContext.Provider
      value={{
        openMenu,
        setOpenMenu,
        openPopup,
        setopenPopup,
        instagramModal,
        setInstagramModal,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useAppContext = (): IContextType => {
  const context = useContext<IContextType | null>(AppContext);

  if (context === undefined || context === null) {
    throw new Error("Context must be used within a Provider");
  }
  return context;
};
